import { Risk } from "../types/types"
type MeasuresAction = {
  type: string
  measure: Risk
}
export const measuresReducer = (measures: Risk[], action: MeasuresAction) => {
  const maxNumberMeasures = window.DMAZE.appConfig.maxNumberMeasures
  switch (action.type) {
    case "PUSH": {
      const measure = action.measure
      if (
        measures.filter((m) => m.parentid === measure.parentid).length <
        maxNumberMeasures
      ) {
        const measureIndex = measures.findIndex((m) => m.id === measure.id)
        if (measureIndex !== -1) {
          const newMeasures = [...measures]
          newMeasures[measureIndex] = measure
          return newMeasures
        }
        return [...measures, measure]
      }
      return measures
    }
    default:
      return measures
  }
}
